// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"38":"b107fc652eaa54b14a9d","88":"5520c4c56caf10a6ec68","105":"8711606acd7db8931198","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"3ee9987f5cd6e5bb888f","852":"2370f94788ba3a80cf8a"}[chunkId] + ".bundle.js";
};